/* tslint:disable */
/* eslint-disable */
/**
 * RoadFootage.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
/**
 * Check if a given object implements the UserProfileDto interface.
 */
export function instanceOfUserProfileDto(value) {
    let isInstance = true;
    return isInstance;
}
export function UserProfileDtoFromJSON(json) {
    return UserProfileDtoFromJSONTyped(json, false);
}
export function UserProfileDtoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'countryCode': !exists(json, 'countryCode') ? undefined : json['countryCode'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'givenName': !exists(json, 'givenName') ? undefined : json['givenName'],
        'familyName': !exists(json, 'familyName') ? undefined : json['familyName'],
        'nickname': !exists(json, 'nickname') ? undefined : json['nickname'],
        'picture': !exists(json, 'picture') ? undefined : json['picture'],
        'phoneNumber': !exists(json, 'phoneNumber') ? undefined : json['phoneNumber'],
        'id': !exists(json, 'id') ? undefined : json['id'],
        'createdAt': !exists(json, 'createdAt') ? undefined : (new Date(json['createdAt'])),
        'updatedAt': !exists(json, 'updatedAt') ? undefined : (new Date(json['updatedAt'])),
        'isActive': !exists(json, 'isActive') ? undefined : json['isActive'],
        'isBanned': !exists(json, 'isBanned') ? undefined : json['isBanned'],
        'isEmailVerified': !exists(json, 'isEmailVerified') ? undefined : json['isEmailVerified'],
        'isPhoneNumberVerified': !exists(json, 'isPhoneNumberVerified') ? undefined : json['isPhoneNumberVerified'],
        'subject': !exists(json, 'subject') ? undefined : json['subject'],
        'emailAddress': !exists(json, 'emailAddress') ? undefined : json['emailAddress'],
        'role': !exists(json, 'role') ? undefined : json['role'],
    };
}
export function UserProfileDtoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'countryCode': value.countryCode,
        'name': value.name,
        'givenName': value.givenName,
        'familyName': value.familyName,
        'nickname': value.nickname,
        'picture': value.picture,
        'phoneNumber': value.phoneNumber,
        'id': value.id,
        'createdAt': value.createdAt === undefined ? undefined : (value.createdAt.toISOString()),
        'updatedAt': value.updatedAt === undefined ? undefined : (value.updatedAt.toISOString()),
        'isActive': value.isActive,
        'isBanned': value.isBanned,
        'isEmailVerified': value.isEmailVerified,
        'isPhoneNumberVerified': value.isPhoneNumberVerified,
        'subject': value.subject,
        'emailAddress': value.emailAddress,
        'role': value.role,
    };
}
